import React from "react";
import "./App.css";

function Eventos() {
  return (
    <div>
      {/* ? Header  */}
      <div className="row">
        <header className="header">
          <nav className="navbar navbar-expand-lg py-3 fixed-top">
            <div className="container">
              <div className="d-flex justify-content-center align-items-center">
                <a
                  className="nav-logo m-0 mx-0 me-lg-3 p-0 text-decoration-none me-md-3"
                  href="/home">
                  HipHop
                </a>
                <img
                  src="/images/svg/cd.svg"
                  alt="cd"
                  id="cd"
                  className="m-0 px-0 d-none d-lg-block d-md-block d-sm-block"
                />
              </div>

              <button
                className=" navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarNav"
                aria-controls="navbarNav"
                aria-expanded="false"
                aria-label="Toggle navigation">
                <span className="navbar-toggler-icon rounded rounded-1 "></span>
              </button>

              <div className="collapse navbar-collapse me-lg-3" id="navbarNav">
                <ul className="nav-ul navbar-nav mx-auto me-0 pe-3 align-items-md-center align-items-center">
                  <li className="mt-md-4 mt-sm-3 mt-4 m-lg-0 nav-item">
                    <a
                      className="px-lg-4 px-md-5 px-sm-5 px-5 nav-link"
                      aria-current="page"
                      href="/home">
                      Inicio
                    </a>
                  </li>
                  <li className="mt-md-3 mt-sm-3 mt-3 m-lg-0 nav-item">
                    <a
                      className="px-lg-4 px-md-5 px-sm-5 px-5 nav-link"
                      aria-current="page"
                      href="/videos">
                      Video clips
                    </a>
                  </li>
                  <li className="mt-md-3 mt-sm-3 mt-3 m-lg-0 nav-item">
                    <a
                      className="px-lg-4 px-md-5 px-sm-5 px-5 nav-link"
                      aria-current="page"
                      href="/disc">
                      Discografía
                    </a>
                  </li>
                  <li className="mt-md-3 mt-sm-3 mt-3 m-lg-0 nav-item">
                    <a
                      className="px-lg-4 px-md-5 px-sm-5 px-5 nav-link"
                      aria-current="page"
                      href="/bio">
                      Biografía
                    </a>
                  </li>
                  <li className="mt-md-3 mt-sm-3 mt-3 m-lg-0 mt-sm-3 nav-item">
                    <a
                      className="px-lg-4 px-md-5 px-sm-5 px-5 nav-link"
                      aria-current="page"
                      href="/eventos">
                      Eventos
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
        </header>
      </div>

      {/* ? Eventos  */}
      <div className="container-events vh-100">
        <article className="events mt-5 p-3">
          <div className="event-top mt-lg-5 text-center">
            <h2 className="event-title">Medellín</h2>
            <h3 className="event-data">10/Ene/2027</h3>
          </div>

          <div className="event-bottom">
            <div className="event-img bg-black">
              <img src="/images/jpg/event.jpg" alt="Evento de Turkano" />
            </div>

            <div className="event-info">
              <p>
                <span id="event-info_title">
                  Lanzamiento del álbum titulado Lo más fresco de la city
                </span>
              </p>
              <p>
                Fecha: <span>10 ENERO 2027</span>
              </p>
              <p>
                Ciudad: <span>Medellín</span>
              </p>

              <div className="event-botons">
                <a id="buy" href="mailto:19117records@gmail.com">
                  Comprar tickets
                </a>
                <a
                  id="com"
                  href="https://youtube.com/@19117records?si=gelRCvPFXe9EEjgH"
                  target="_blank"
                  rel="noreferrer">
                  <img src="/images/svg/compartir.svg" alt="Compartir" />
                  Compartir
                </a>
              </div>
            </div>
          </div>
        </article>
      </div>

      {/* ? Footer  */}
      <footer className="footer">
        <div className="container d-flex flex-column align-items-center p-3 pb-0">
          <h1 className="footer-title text-center">
            Escúchanos en <br /> <span className="">Plataformas</span>
          </h1>

          <div className="footer-imgs d-flex justify-content-around w-75 mt-4">
            <a
              href="https://youtube.com/@19117records?si=gelRCvPFXe9EEjgH"
              target="_blank"
              rel="noreferrer">
              <img
                src="/images/svg/youtube-f-w.svg"
                alt="YouTube"
                width="170"
                title="YouTube"
                id="img-yt"
              />
            </a>
            <a
              href="https://youtube.com/@19117records?si=gelRCvPFXe9EEjgH"
              target="_blank"
              rel="noreferrer">
              <img
                src="/images/svg/yt_music-f-w.svg"
                alt="YouTube Music"
                width="80"
                title="YouTube Music"
              />
            </a>
            <a
              href="https://open.spotify.com/intl-es/artist/4xU5vqImsU2aw0egTk7p68?si=HFFGGeUcR2i29alfqrSfUg"
              target="_blank"
              rel="noreferrer">
              <img
                src="/images/svg/spotify-f-w.svg"
                alt="Spotify"
                width="80"
                title="Spotify"
              />
            </a>
            <a
              href="https://link.deezer.com/s/33gNTeFkFpklf7NWxT4D7"
              target="_blank"
              rel="noreferrer">
              <img
                src="/images/svg/deezer-f-w.svg"
                alt="Deezer"
                width="80"
                title="Deezer"
              />
            </a>
          </div>

          <div className="comunication w-50 d-lg-flex justify-content-around align-items-center py-3 pb-5 d-grid col-1">
            <div className="footer-contact text-center">
              <h2>Contacto</h2>
              <p>19117records@gmail.com</p>
              <p>3146148505</p>
            </div>
          </div>
        </div>

        <div className="copy d-flex justify-content-between mx-3 fs-6">
          <p>2023, &copy; TURKANO</p>
          <p className="otto text-uppercase">&copy; OTTO | Carlos Arteaga</p>
        </div>
      </footer>
    </div>
  );
}

export default Eventos;
